"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var MultipleSelectTreeItemModule = /** @class */ (function () {
    function MultipleSelectTreeItemModule() {
    }
    return MultipleSelectTreeItemModule;
}());
exports.MultipleSelectTreeItemModule = MultipleSelectTreeItemModule;
